import { r as registerInstance, h, e as Host } from './index-bfb2bce5.js';

const ttuiContentImageCss = ":host{display:block}img{max-width:100%;min-width:100%;max-height:var(--max-content-width)}";

const ContentImage = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.src = '';
    this.alt = '';
  }
  render() {
    return (h(Host, null, h("img", { src: this.src, alt: this.alt })));
  }
};
ContentImage.style = ttuiContentImageCss;

export { ContentImage as ttui_content_image };

//# sourceMappingURL=ttui-content-image.entry.js.map